"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var className = _ref.className,
      address = _ref.address,
      city = _ref.city,
      state = _ref.state,
      postcode = _ref.postcode;
  var classes = ['address-full'];

  if (className) {
    classes.push(className);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "street"
  }, address), /*#__PURE__*/_react.default.createElement("div", {
    className: "city-state-postcode"
  }, city && state && "".concat(city, ", ").concat(state, " "), postcode));
}